var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoBannerFoundBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 321,
    viewBox: "0 0 600 321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.014,
    x2: 0.5,
    y2: 0.559,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_178644",
    "data-name": "Group 178644",
    transform: "translate(-2579 7713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178642",
    "data-name": "Group 178642",
    transform: "translate(2160 -8056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178639",
    "data-name": "Group 178639"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_464",
    "data-name": "Ellipse 464",
    cx: 300,
    cy: 90,
    rx: 300,
    ry: 90,
    transform: "translate(419 484)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_179874",
    "data-name": "Group 179874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(2408.236 -8120.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178595",
    "data-name": "Group 178595",
    transform: "translate(401.764 407.143)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1788",
    "data-name": "Ellipse 1788",
    cx: 100,
    cy: 100,
    r: 100,
    transform: "translate(7.176 0)",
    fill: "#dddfdd",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_178594",
    "data-name": "Group 178594",
    transform: "translate(0 29.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178622",
    "data-name": "Group 178622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178576",
    "data-name": "Group 178576",
    transform: "translate(0 18.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178573",
    "data-name": "Group 178573",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29445",
    "data-name": "Path 29445",
    d: "M499.375,699.157V849.143L388.4,836.824a12.317,12.317,0,1,1-24.635,0V717.393L382,699.157Z",
    transform: "translate(-362.758 -698.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29446",
    "data-name": "Path 29446",
    d: "M494.382,845.156a.984.984,0,0,1-.111-.006l-109.9-12.2a13.324,13.324,0,0,1-26.6-1.12V712.4a1.008,1.008,0,0,1,.295-.712L376.3,693.452a1.007,1.007,0,0,1,.712-.295H494.382a1.007,1.007,0,0,1,1.007,1.007V844.149a1.007,1.007,0,0,1-1.007,1.007Zm-134.6-132.339V831.83a11.31,11.31,0,1,0,22.621,0,1.007,1.007,0,0,1,1.118-1l109.857,12.2V695.171H377.424Z",
    transform: "translate(-357.765 -693.157)",
    fill: "#dddfdd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178574",
    "data-name": "Group 178574",
    transform: "translate(12.317 137.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29447",
    "data-name": "Path 29447",
    d: "M560.447,1531.773H437.154a12.319,12.319,0,0,0,12.318-12.318Z",
    transform: "translate(-436.147 -1518.448)",
    fill: "#dddfdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29448",
    "data-name": "Path 29448",
    d: "M555.454,1527.786H432.161a1.007,1.007,0,1,1,0-2.014,11.324,11.324,0,0,0,11.311-11.311,1.007,1.007,0,0,1,1.118-1l110.975,12.318a1.007,1.007,0,0,1-.111,2.008ZM439.2,1525.772h98.057l-91.816-10.192A13.338,13.338,0,0,1,439.2,1525.772Z",
    transform: "translate(-431.154 -1513.453)",
    fill: "#dddfdd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178575",
    "data-name": "Group 178575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29449",
    "data-name": "Path 29449",
    d: "M382,699.157v18.237H363.765Z",
    transform: "translate(-362.758 -698.15)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29450",
    "data-name": "Path 29450",
    d: "M377.006,713.407H358.771a1.007,1.007,0,0,1-.712-1.719l18.235-18.236a1.007,1.007,0,0,1,1.719.712V712.4A1.007,1.007,0,0,1,377.006,713.407Zm-15.8-2.014H376v-14.8Z",
    transform: "translate(-357.764 -693.157)",
    fill: "#dddfdd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_178585",
    "data-name": "Group 178585",
    transform: "translate(14.857 50.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178577",
    "data-name": "Group 178577"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146433",
    "data-name": "Rectangle 146433",
    width: 24.638,
    height: 2.014,
    fill: "#dddfdd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178578",
    "data-name": "Group 178578",
    transform: "translate(0 13.487)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146434",
    "data-name": "Rectangle 146434",
    width: 106.566,
    height: 2.014,
    fill: "#dddfdd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178579",
    "data-name": "Group 178579",
    transform: "translate(0 26.974)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146435",
    "data-name": "Rectangle 146435",
    width: 106.566,
    height: 2.014,
    fill: "#dddfdd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178580",
    "data-name": "Group 178580",
    transform: "translate(0 40.462)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146436",
    "data-name": "Rectangle 146436",
    width: 106.566,
    height: 2.014,
    fill: "#dddfdd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178581",
    "data-name": "Group 178581",
    transform: "translate(0 53.949)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146437",
    "data-name": "Rectangle 146437",
    width: 106.566,
    height: 2.014,
    fill: "#dddfdd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178582",
    "data-name": "Group 178582",
    transform: "translate(0 67.436)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146438",
    "data-name": "Rectangle 146438",
    width: 106.566,
    height: 2.014,
    fill: "#dddfdd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178583",
    "data-name": "Group 178583",
    transform: "translate(0 80.923)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146439",
    "data-name": "Rectangle 146439",
    width: 106.566,
    height: 2.014,
    fill: "#dddfdd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178584",
    "data-name": "Group 178584",
    transform: "translate(0 94.411)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146440",
    "data-name": "Rectangle 146440",
    width: 61.12,
    height: 2.014,
    fill: "#dddfdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_178593",
    "data-name": "Group 178593",
    transform: "translate(81.075 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178586",
    "data-name": "Group 178586",
    transform: "translate(-0.075 0.243)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1789",
    "data-name": "Ellipse 1789",
    cx: 39.393,
    cy: 39.393,
    r: 39.393,
    transform: "translate(0.607 0.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29451",
    "data-name": "Path 29451",
    d: "M687.879,682.894a39.876,39.876,0,1,1,15.052-2.929A39.869,39.869,0,0,1,687.879,682.894Zm0-78.768a38.768,38.768,0,1,0,27.426,11.342A38.665,38.665,0,0,0,687.879,604.126Z",
    transform: "translate(-647.879 -602.894)",
    fill: "#dddfdd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29452",
    "data-name": "Path 29452",
    d: "M800.92,710.111a30.18,30.18,0,0,0-42.607,42.607,30.18,30.18,0,1,1,42.607-42.607Z",
    transform: "translate(-738.051 -690.108)",
    fill: "#f5f5f7",
    opacity: 0.997
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_178587",
    "data-name": "Group 178587",
    transform: "translate(9.505 9.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29453",
    "data-name": "Path 29453",
    d: "M772.886,756.5A30.868,30.868,0,1,1,803.28,720.2l.106.6-1.195.212-.106-.6a29.657,29.657,0,1,0,.009,10.4l.105-.6,1.2.21-.105.6a30.88,30.88,0,0,1-30.4,25.487Z",
    transform: "translate(-742.015 -694.761)",
    fill: "#dddfdd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178609",
    "data-name": "Group 178609",
    transform: "translate(26.277 25.942)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178605",
    "data-name": "Group 178605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178602",
    "data-name": "Group 178602",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29460",
    "data-name": "Path 29460",
    d: "M1049.277,327.486a1.542,1.542,0,0,1-1.123-.482l-24.2-25.507a1.547,1.547,0,0,1,2.244-2.13l24.2,25.507a1.547,1.547,0,0,1-1.122,2.612Z",
    transform: "translate(-1023.527 -298.885)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178603",
    "data-name": "Group 178603",
    transform: "translate(0.694 0.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29461",
    "data-name": "Path 29461",
    d: "M1067.912,345.427a.852.852,0,0,1-.62-.266l-24.2-25.507a.854.854,0,0,1,1.239-1.175l24.2,25.507a.854.854,0,0,1-.619,1.441Z",
    transform: "translate(-1042.855 -318.213)",
    fill: "#878888"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_178608",
    "data-name": "Group 178608",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178602-2",
    "data-name": "Group 178602",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29460-2",
    "data-name": "Path 29460",
    d: "M1025.073,327.486A1.542,1.542,0,0,0,1026.2,327l24.2-25.507a1.547,1.547,0,1,0-2.244-2.13l-24.2,25.507a1.547,1.547,0,0,0,1.122,2.612Z",
    transform: "translate(-1023.527 -298.885)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178603-2",
    "data-name": "Group 178603",
    transform: "translate(0.694 0.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29461-2",
    "data-name": "Path 29461",
    d: "M1043.708,345.427a.852.852,0,0,0,.62-.266l24.2-25.507a.854.854,0,0,0-1.239-1.175l-24.2,25.507a.854.854,0,0,0,.619,1.441Z",
    transform: "translate(-1042.855 -318.213)",
    fill: "#878888"
  })))))))), /*#__PURE__*/React.createElement("text", {
    id: "Create_your_first_Banner",
    "data-name": "Create your first Banner",
    transform: "translate(2879 -7481)",
    fill: "#54565b",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans,sans-serif",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -87,
    y: 0
  }, "Create your first Banner"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBannerFoundBg);
export default __webpack_public_path__ + "static/media/noBannerFoundBg.ede74323a39def3396ee91369cb38637.svg";
export { ForwardRef as ReactComponent };